import { metaKeyInBrowser } from '@bonsai-components/meta-key';
import { ModIconButton } from '@moderneinc/design-system-components';
import { iconSize, semanticColors } from '@moderneinc/design-system-tokens';
import { Box, ButtonBase, Stack, Tooltip, Typography } from '@mui/material';
import React, { type FunctionComponent } from 'react';
import { SEARCH_BAR_PLACEHOLDER } from '../../constants/messages';
import { navFieldSx, topNavIconButtonSx } from '../../constants/sx';
import { SearchIcon } from '../../icons/icons';
import { ShortcutKey } from '../keyboard-shortcuts/keyboard-shortcuts.component';

type SearchTriggerProps = {
  onClick: () => void;
};

export const SearchTrigger: FunctionComponent<SearchTriggerProps> = ({
  onClick
}) => {
  return (
    <React.Fragment>
      {/* Compact icon button for smaller screens */}
      <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
        <Tooltip title="Search">
          <ModIconButton
            onClick={onClick}
            aria-label="Search"
            variant="nav"
            sx={topNavIconButtonSx}
          >
            <SearchIcon size={iconSize.md} />
          </ModIconButton>
        </Tooltip>
      </Box>
      {/* Full pill trigger for larger screens */}
      <ButtonBase
        onClick={onClick}
        disableRipple
        aria-label="Search recipes"
        data-tour="open-search"
        sx={{
          ...navFieldSx,
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          gap: 1.5,
          userSelect: 'none',
          // Fixed 280px to match the mock's search field.
          width: 280
        }}
      >
        <SearchIcon
          size={iconSize.md}
          style={{
            color: semanticColors.color.icon.utility,
            flexShrink: 0
          }}
        />
        <Typography
          variant="bodySm"
          sx={{
            // Flex-grow pushes the ⌘K keys to the right edge, as in the mock;
            // textAlign resets the ButtonBase's inherited center so the
            // placeholder sits left, next to the icon.
            flexGrow: 1,
            textAlign: 'left',
            color: semanticColors.color.text.inputPlaceholder,
            whiteSpace: 'nowrap'
          }}
        >
          {SEARCH_BAR_PLACEHOLDER}
        </Typography>
        <Stack
          direction="row"
          sx={{
            gap: 0.25,
            alignItems: 'center'
          }}
        >
          <ShortcutKey>{metaKeyInBrowser({ windows: 'Ctrl' })}</ShortcutKey>
          <ShortcutKey>K</ShortcutKey>
        </Stack>
      </ButtonBase>
    </React.Fragment>
  );
};
